// extracted by mini-css-extract-plugin
module.exports = {"promoBox":"PromoBox_promoBox__bbfjI"};